export default __webpack_public_path__ + "static/media/2_Intro.0c4db792.mp4";